// PostHog analytics — env-driven, single instance.
// Reads REACT_APP_POSTHOG_KEY / REACT_APP_POSTHOG_HOST. When either is
// missing, analytics is safely disabled (no init, no window.posthog) so the
// site keeps working without configuration. Mirrors the initSentry() pattern.
import posthog from "posthog-js";

// Non-PII environment tag attached to every event as a super property.
const resolveEnvironment = () => {
  if (typeof window === "undefined") return "development";
  const h = window.location.hostname;
  if (h === "cleanbid.ai" || h === "www.cleanbid.ai") return "production";
  if (h === "localhost" || h === "127.0.0.1") return "development";
  return "preview"; // Emergent preview hosts (and any other non-prod host)
};

let started = false;

export const initPostHog = () => {
  if (started) return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST;
  if (!key || !host) return; // safe-disable when unconfigured

  started = true;
  posthog.init(key, {
    api_host: host,
    person_profiles: "identified_only",
    capture_performance: false,
    disable_session_recording: true,
  });
  // Registered synchronously after init so it is present on the first
  // $pageview and on every subsequent event (autocapture + custom events).
  posthog.register({ environment: resolveEnvironment() });

  // Preserve existing consumers that read window.posthog (e.g. the marketing
  // analytics wrapper). Keeps exactly one instance.
  if (typeof window !== "undefined") window.posthog = posthog;
};

export default posthog;
